import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const dictionary = {
  product_details: {
    'en-GB': 'Product details',
    'nl-NL': 'Omschrijving',
  },
}

export const useProductDetailsLocaleText = createLocaleTextHook({
  dictionary,
})
